// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dragButton:hover {\r\n\tcursor: move; /* fallback if grab cursor is unsupported */\r\n\tcursor: grab !important;\r\n\tcursor: -webkit-grab;\r\n}\r\n\r\n.dragButton:active {\r\n\tcursor: grabbing !important;\r\n\tcursor: -webkit-grabbing;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
